export class LocalAddress {

  public address1;
  public address2;
  public address3;
  public city;
  public state;
  public zip;
  public country;

  public displayLines: string[] = [];

  static fromDto(a): LocalAddress {
    const address = new LocalAddress();

    if (!a) {
      return null;
    }

    address.address1 = a.address1;
    address.address2 = a.address2;
    address.address3 = a.address3;
    address.city     = a.city;
    address.state    = a.state;
    address.zip      = a.zip;
    address.country  = a.country;

    const line1 = [address.address1, address.address2, address.address3].filter(s => null !== s).join(', ');
    const line2 = [address.zip, address.city, address.state, address.country].filter(s => null !== s).join(', ');

    address.displayLines = [line1, line2].filter(s => null !== s);

    return address;
  }

  public toDto() {
    return {
      address1: this.address1,
      address2: this.address2,
      address3: this.address3,
      city: this.city,
      state: this.state,
      zip: this.zip,
      country: this.country,
    };
  }

  public toString() {
    return `${this.address1 + ', ' || ''} ${this.address2 ? this.address2 + ', ' : ''} ${this.address3 ? this.address3 + ', ' : ''}
        ${this.city + ', '} ${this.state ? this.state + ', ' : ''} ${this.zip + ', '} ${this.country}
        `
  }
}
